import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import time from "../../../imgs/Icons/time_black.svg";
import { withNamespaces } from 'react-i18next';

const ServicosSaude = ({t}) => {

  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }
  return (
    <>
      <div className="accordion accordions_margin" id="accordionExample_sSaude">
        {/* 1 - HOSPITAL PUBLICO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="hPublico">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cHPublico"
              aria-expanded="true"
              aria-controls="cHPublico"
            >
              {t('moduleContactosEmergencia:S2.A.A1.T')}
            </button>
          </h2>
          <div
            id="cHPublico"
            className="accordion-collapse collapse"
            aria-labelledby="hPublico"
            data-bs-parent="#accordionExample_sSaude"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p className="p-bold">{t('moduleContactosEmergencia:S2.A.A1.ST1.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A1.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A1.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A1.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A1.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEmergencia:S2.A.A1.ST1.P3')}>
                    {t('moduleContactosEmergencia:S2.A.A1.ST1.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S2.A.A1.ST1.P4')}
                  >
                    {t('moduleContactosEmergencia:S2.A.A1.ST1.P4')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A1.ST1.P5')}
                </p>
                <p className="p-bold marginT-p">{t('moduleContactosEmergencia:S2.A.A1.ST2.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>{t('moduleContactosEmergencia:S2.A.A1.ST2.P1')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S2.A.A1.ST2.P2')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A1.ST2.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - HOSPITAL PRIVADO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="hPrivado">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cHPrivado"
              aria-expanded="true"
              aria-controls="cHPrivado"
            >
              {t('moduleContactosEmergencia:S2.A.A2.T')}
            </button>
          </h2>
          <div
            id="cHPrivado"
            className="accordion-collapse collapse"
            aria-labelledby="hPrivado"
            data-bs-parent="#accordionExample_sSaude"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p className="p-bold">{t('moduleContactosEmergencia:S2.A.A2.ST1.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A2.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A2.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEmergencia:S2.A.A2.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A2.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEmergencia:S2.A.A2.ST1.P3')}>
                    {t('moduleContactosEmergencia:S2.A.A2.ST1.P3')}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>{t('moduleContactosEmergencia:S2.A.A2.ST1.P4')}
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEmergencia:S2.A.A2.ST1.P5')}>
                    {t('moduleContactosEmergencia:S2.A.A2.ST1.P5')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S2.A.A2.ST1.P6')}
                  >
                    {t('moduleContactosEmergencia:S2.A.A2.ST1.P6')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A2.ST1.P7')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S2.A.A2.ST1.P8')}
                </p>
                <p className="p-bold marginT-p">{t('moduleContactosEmergencia:S2.A.A2.ST2.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A2.ST2.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A2.ST2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S2.A.A2.ST2.P2')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A2.ST2.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - CENTRO DE SAUDE */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="centroSaude">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cCentroSaude"
              aria-expanded="true"
              aria-controls="cCentroSaude"
            >
              {t('moduleContactosEmergencia:S2.A.A3.T')}
            </button>
          </h2>
          <div
            id="cCentroSaude"
            className="accordion-collapse collapse"
            aria-labelledby="centroSaude"
            data-bs-parent="#accordionExample_sSaude"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A3.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A3.P1'))}
                  </a>
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A3.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A3.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEmergencia:S2.A.A3.P3')}>
                    {t('moduleContactosEmergencia:S2.A.A3.P3')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S2.A.A3.P4')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A3.P5')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - FARMACIAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="farmacias">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cFarmacias"
              aria-expanded="true"
              aria-controls="cFarmacias"
            >
              {t('moduleContactosEmergencia:S2.A.A4.T')}
            </button>
          </h2>
          <div
            id="cFarmacias"
            className="accordion-collapse collapse"
            aria-labelledby="farmacias"
            data-bs-parent="#accordionExample_sSaude"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEmergencia:S2.A.A4.P1')}
                  >
                    {t('moduleContactosEmergencia:S2.A.A4.P1')}
                  </a>
                </p>
                <p className="p-bold">{t('moduleContactosEmergencia:S2.A.A4.ST1.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEmergencia:S2.A.A4.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S2.A.A4.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S2.A.A4.ST1.P2')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A4.ST1.P3')}
                </p>
                <p className="p-bold marginT-p">{t('moduleContactosEmergencia:S2.A.A4.ST2.ST')}</p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S2.A.A4.ST2.P1')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>{t('moduleContactosEmergencia:S2.A.A4.ST2.P2')}
                </p>

                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S2.A.A4.ST2.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (ServicosSaude);
